import * as React from 'react';
import 'rxjs/add/operator/debounceTime';
import { Observable } from 'rxjs/Observable';
import './loader.component.style.scss';

export interface LoaderComponentProps {
    isLoading$?: Observable<boolean>;
}

export class LoaderComponent extends React.Component<LoaderComponentProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    componentWillMount() {
        if (this.props.isLoading$) {
            this.props.isLoading$.debounceTime(50).subscribe((value: boolean) => {
                this.setState({isLoading: value});
            });
        }
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div className="loader-container">
                    <div className="d-flex flex-row h-100 justify-content-center ">
                        <div className="align-self-center text-center">
                            <div className="fidgetspinner-loader"/>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (<div/>);
        }
    }
}

/*
 <!-- <i className="fa fa-5x fa-circle-o-notch fa-spin"/>
 <h1 className="pt-4">Loading...</h1> -->
 */



// WEBPACK FOOTER //
// ./src/components/structurals/loader.component.tsx